export const CONTENT_UPDATE = 'contentApi/CONTENT_UPDATE';

export const contentUpdate = (data) => ({
  type: CONTENT_UPDATE,
  data
});
